/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-wikis': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm7.5 8.125h-3.75a15.163 15.163 0 00-1.744-6.594A7.5 7.5 0 0117.5 9.375zM10 17.5c-.14.01-.28.01-.419 0A13.656 13.656 0 017.5 10.625h5a13.656 13.656 0 01-2.063 6.875c-.145.01-.291.01-.437 0zM7.5 9.375A13.656 13.656 0 019.563 2.5a3.75 3.75 0 01.837 0 13.656 13.656 0 012.1 6.875h-5zm.475-6.594A15.162 15.162 0 006.25 9.375H2.5a7.5 7.5 0 015.494-6.594h-.019zm-5.444 7.844h3.75c.065 2.3.653 4.555 1.719 6.594a7.5 7.5 0 01-5.469-6.594zm9.475 6.594a15.163 15.163 0 001.744-6.594h3.75a7.5 7.5 0 01-5.494 6.594z"/>'
  }
})
